import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { castArray } from 'lodash';
import React, { FC, ReactNode } from 'react';

import { ImageProps } from 'src/components/image';
import { Link } from 'src/components/link';
import { config } from 'src/config/config';
import { i18n } from 'src/i18n';
import { navigationService } from 'src/services/navigation-service';
import { I18nUtils } from 'src/utils/i18n-utils';

import { StyledButton, StyledContainer, StyledImage, StyledSubtitle } from './common-error.styled';

interface Props {
  title: string;
  subtitle: ReactNode | ReactNode[];
  image: ImageProps;
  hideCustomerServiceText?: boolean;
  onButtonClick?: () => void;
  buttonText?: string;
}

export const CommonError: FC<Props> = (props) => {
  const {
    title,
    image,
    subtitle,
    hideCustomerServiceText,
    onButtonClick = navigationService.goToMineSider,
    buttonText = i18n.component.commonError.goToMineSider,
  } = props;

  const renderContactCustomerService = () =>
    I18nUtils.richMessage(i18n.component.commonError.contactCustomerService, {
      linkToCustomerService: (
        <Link variant="paragraph2" target="_blank" href={config.CUSTOMER_SERVICE}>
          {i18n.component.commonError.linkToCustomerService}
        </Link>
      ),
    });

  return (
    <StyledContainer>
      <Typography variant="headline2" component="h1">
        {title}
      </Typography>
      <StyledImage {...image} />
      {castArray(subtitle).map((subheading, index) => (
        <StyledSubtitle key={index} component="p" variant="paragraph2">
          {subheading}
        </StyledSubtitle>
      ))}
      {!hideCustomerServiceText && (
        <StyledSubtitle variant="paragraph2" component="p">
          {renderContactCustomerService()}
        </StyledSubtitle>
      )}
      <StyledButton onClick={onButtonClick}>{buttonText}</StyledButton>
    </StyledContainer>
  );
};
